import React from "react";
import { makeStyles } from "helpers/StyleHelper";
import { useTheme } from "@mui/material/styles";
import { Question } from "services/KnowfullyAdminClient";
import HTMLQuestion from "components/HTMLQuestion";
import { Box } from "@mui/material";

const useStyles = makeStyles({
  question: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "4",
    lineClamp: 4,
    WebkitBoxOrient: "vertical",
  },
});

const TruncatedQuestion = ({ value }: { value: Question }) => {
  const styles = useStyles(useTheme());
  return (
    <Box sx={styles.question}>
      <HTMLQuestion question={value} />
    </Box>
  );
};

export default TruncatedQuestion;
